import { render, staticRenderFns } from "./SupwisdomAssociation.vue?vue&type=template&id=7bc70021&scoped=true&"
import script from "./SupwisdomAssociation.vue?vue&type=script&lang=ts&"
export * from "./SupwisdomAssociation.vue?vue&type=script&lang=ts&"
import style0 from "./SupwisdomAssociation.vue?vue&type=style&index=0&id=7bc70021&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc70021",
  null
  
)

export default component.exports